export default {"src":"/_next/static/media/typescript.a173c8ca.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};